import { useState, useEffect } from "react";
import logo from "../images/logo1.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = ["Home", "Services", "Projects", "About", "Contact"];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled ? "bg-white shadow-lg shadow-red-100/50" : "bg-transparent"
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo - Using imported image */}
        <a href="#home" className="flex items-center gap-3">
          <img 
            src={logo} 
            alt="NexEdge Infra Logo" 
            className={`w-[120px] h-[80px] object-contain transition-all duration-300 ${
              scrolled ? "scale-100" : "scale-105"
            }`}
          />
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <a key={l} href={`#${l.toLowerCase()}`}
              className={`nav-link text-sm font-medium tracking-wide transition-colors ${
                scrolled ? "text-red-900 hover:text-blue-700" : "text-white/90 hover:text-white"
              }`}
              style={{ fontFamily: "'DM Sans', sans-serif" }}>
              {l}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a href="#contact"
          className="hidden md:block bg-gradient-to-r from-red-900 to-blue-900 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:from-red-800 hover:to-blue-800 transition-all duration-300 shadow-lg shadow-red-900/30">
          Get Quote
        </a>

        {/* Mobile Menu Button */}
        <button className={`md:hidden ${scrolled ? "text-red-900" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-xl px-6 py-4 flex flex-col gap-4">
          {links.map(l => (
            <a key={l} href={`#${l.toLowerCase()}`}
              className="text-red-900 font-medium py-2 border-b border-red-50"
              onClick={() => setMenuOpen(false)}>
              {l}
            </a>
          ))}
          <a href="#contact"
            className="bg-gradient-to-r from-red-900 to-blue-900 text-white px-6 py-3 rounded-lg text-center font-semibold">
            Get Quote
          </a>
        </div>
      )}
    </nav>
  );
}